import { BODY_SM_SM_MEDIUM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const PathwaysAvailable = styled.div`
    ${BODY_SM_SM_MEDIUM_STYLES};
    color: var(--colors-text-on-disabled, #70768d);
    display: flex;
    align-items: center;
    gap: 20px;
`;

export const ShowMore = styled.div`
    ${BODY_SM_SM_MEDIUM_STYLES};
    color: var(--colors-text-action, #2171c6);
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    max-width: 1115px;
    width: 100%;
`;

export const ArrowsWrapper = styled.div`
    min-width: 88px;
`;

export const ShowMoreTextWrapper = styled.div`
    user-select: none;
    cursor: pointer;
`;
